import { BaseService } from '../BaseService';
import { BaseEntitiesService } from './BaseEntitiesService';
import { createObjectsCache, createSingleton } from '../singleton';
import { DatasetsRepository, DataSourceRepository, OneConfigRepository, ConfigsRepository, TopicDatasetMapsRepository, TopicsRepository, UserDatasetMapsRepository, UserGroupsRepository, UsersRepository, } from '../repositories/adm';
//
//          
//
export class UsersService extends BaseEntitiesService {
    constructor() {
        super(new UsersRepository());
        this._rtSync = false;
    }
    static getInstance = createSingleton(() => new UsersService(), '__usersService');
}
//
//             
//
export class DatasetsService extends BaseEntitiesService {
    constructor() {
        super(new DatasetsRepository());
    }
    static getInstance = createSingleton(() => new DatasetsService(), '__datasetsService');
}
//
//           
//
export class TopicsService extends BaseEntitiesService {
    constructor() {
        super(new TopicsRepository());
    }
    static getInstance = createSingleton(() => new TopicsService(), '__topicsService');
}
//
//                       
//
export class TopicDatasetMapsService extends BaseEntitiesService {
    constructor() {
        super(new TopicDatasetMapsRepository());
    }
    static getInstance = createSingleton(() => new TopicDatasetMapsService(), '__topicDatasetMapsService');
}
//
//                
//
export class UserGroupsService extends BaseEntitiesService {
    constructor() {
        super(new UserGroupsRepository());
    }
    static getInstance = createSingleton(() => new UserGroupsService(), '__userGroupsService');
}
export class UserDatasetMapsService extends BaseEntitiesService {
    constructor() {
        super(new UserDatasetMapsRepository());
    }
    static getInstance = createSingleton(() => new UserDatasetMapsService(), '__adm__user_dataset_maps');
}
//
//                  
//
export class DataSourcesService extends BaseEntitiesService {
    constructor() {
        super(new DataSourceRepository());
        this._rtSync = false; //                                              
    }
    static getInstance = createSingleton(() => new DataSourcesService(), '__dataSourcesService');
}
//
//            
//
export class SystemConfigurationService extends BaseEntitiesService {
    constructor() {
        super(new ConfigsRepository());
    }
    static getModel() {
        return this.getInstance().getModel();
    }
    static getInstance = createSingleton(() => new SystemConfigurationService(), '__systemConfigurationService');
}
class OneConfigRecordService extends BaseEntitiesService {
    cfg_key;
    constructor(cfg_key) {
        super(new OneConfigRepository(cfg_key));
        this.cfg_key = cfg_key;
    }
    _dispose() {
        OneConfigRecordService._cache.remove(this.cfg_key);
        super._dispose();
    }
    static _cache = createObjectsCache((cfg_key) => new OneConfigRecordService(String(cfg_key)));
    static createInstance = OneConfigRecordService._cache.get;
}
export class OneConfigService extends BaseService {
    static MODEL;
    _recordService;
    constructor(cfg_key) {
        super({
            error: null,
            loading: true,
            cfg_key,
            cfg_val: null,
            is_enabled: 0,
        });
        this._recordService = OneConfigRecordService.createInstance(cfg_key);
        this._recordService.subscribeUpdatesAndNotify(this._onSvcUpdated);
    }
    _dispose() {
        this._recordService.unsubscribe(this._onSvcUpdated);
        this._recordService.release();
        super._dispose();
    }
    async set(cfg_val) {
        const model = this._recordService.getModel();
        const cfg_key = this._recordService.cfg_key;
        if (model.length) {
            return this._recordService.updateOne(cfg_key, { cfg_val });
        }
        else {
            return this._recordService.create({ cfg_key, cfg_val });
        }
    }
    _onSvcUpdated = (model) => {
        if (model.error)
            return this._updateWithError(model.error);
        if (model.loading)
            return this._updateWithLoading();
        if (model.length === 0)
            return this._updateWithData({ cfg_val: null });
        this._updateWithData({
            cfg_val: model[0].cfg_val ?? model[0].default_val ?? null,
            is_enabled: model[0].is_enabled,
        });
    };
    static _cache = createObjectsCache((cfg_key) => new OneConfigService(String(cfg_key)));
    static createInstance = OneConfigService._cache.get;
}
